module.exports = __webpack_public_path__ + "static/media/anaAwardFuture-head.af830bbc.png";